import {Component, computed, inject, input} from '@angular/core';
import {GameStore} from '../../store/game.store';
import {ResourcesService} from '../../services/resources.service';
import {ScoreClassification} from "../../store/features/with-score.feature";

@Component({
  selector: 'gis-score-bar',
  imports: [],
  templateUrl: './score-bar.component.html',
  styleUrls: ['./score-bar.component.scss']
})
export class ScoreBarComponent {
  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  readonly showEarnedPointsLabel = input(true);
  readonly showIcon = input(true);
  readonly standalone = input(true);

  protected readonly fillWidth = computed(() =>
    (this.store.currentScore() / this.store.maxScore()) * 100
  );

  protected readonly accessibleScoreStatus = computed(() => {
    const template = this.resourcesService.languageFile.value().scoreStatus;
    return template
      .replace('%%', this.store.currentScore().toString())
      .replace('%%', this.store.maxScore().toString());
  });

  protected readonly showEarnedPoints = computed(() =>
    this.showEarnedPointsLabel() && this.store.questionState().feedback === 'correct'
  );

  protected readonly earnedPointsLabel = computed(() => {
    const template = this.resourcesService.languageFile.value().pointsEarnedShort;
    return template.replace('%%', this.store.earnedPointsForCurrentQuestion().toString());
  });
  protected readonly ScoreClassification = ScoreClassification;
}
